var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('b-button',{style:({color: 'white', backgroundColor: _vm.hiddenFeatures.horizontalScrollbar ? 'black' : 'darkgray' }),attrs:{"size":"sm"},on:{"click":_vm.toggle}},[_vm._v(" scrollbar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }